import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

let messagingInstance = null;
let swRegistration = null;

async function getMessagingInstance() {
  if (messagingInstance) return messagingInstance;
  messagingInstance = getMessaging(app);
  return messagingInstance;
}

export async function requestNotificationPermission() {
  try {
    if (!("Notification" in window) || !("serviceWorker" in navigator)) {
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      return null;
    }

    swRegistration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js",
      { scope: "/firebase-cloud-messaging-push-scope" }
    );

    // Force check for updated service worker
    swRegistration.update();

    await new Promise((resolve) => {
      if (swRegistration.active) {
        resolve();
      } else {
        const sw = swRegistration.installing || swRegistration.waiting;
        if (sw) {
          sw.addEventListener("statechange", (e) => {
            if (e.target.state === "activated") resolve();
          });
        } else {
          resolve();
        }
      }
    });

    const messaging = await getMessagingInstance();
    const token = await getToken(messaging, {
      vapidKey: process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: swRegistration,
    });

    // Set up foreground message listener
    onMessage(messaging, (payload) => {
      const data = payload.data || {};
      const title = data.title || payload.notification?.title;
      const body = data.body || payload.notification?.body;

      // Show system notification via service worker (so notificationclick handler works)
      if (title && Notification.permission === "granted") {
        try {
          if (swRegistration && swRegistration.active) {
            // Tell the service worker to show the notification
            swRegistration.active.postMessage({
              type: "SHOW_NOTIFICATION",
              title,
              body,
              data,
            });
          } else {
            new Notification(title, { body: body, icon: "/favicon.ico" });
          }
        } catch (e) {
          new Notification(title, { body: body, icon: "/favicon.ico" });
        }
      }

      window.dispatchEvent(new CustomEvent("fcm-message", { detail: { title, body, data } }));
    });

    return token;
  } catch (error) {
    return null;
  }
}
